/**
 * 打开新视图
 * 目前适用于卡牛，随手记
 */
import useragent from '@common/useragent'
import { absUrl } from '@common/host'
import { call, uriSuishouji, uriSuiguanjia } from './bridge'
import { compare } from './version'

export default (_url, callBack) => {
  const url = absUrl(_url)
  if (useragent.isSuishouji) {
    call(uriSuishouji('requestMarket', { url }))
  } else if (useragent.isKaniu) {
    const featureVersion = useragent.isAndroid ? '7.7.7' : '7.7.2'
    call('cardniu://api/getUserInfo', 'onGetUserInfo', (dataInfo) => {
      if (compare(featureVersion, dataInfo.version)) {
        call(`cardniu://app/newWindowOpen?url=${encodeURIComponent(url)}`)
      } else {
        window.location.href = url
      }
    })
  } else if (useragent.isSuiguanjia) {
    const uri = uriSuiguanjia('sgj://app/webview/newWindowOpen', {
      url,
    }, 'onNewView')
    call(uri, 'onNewView', callBack)
  } else {
    window.location.href = url
  }
}



// WEBPACK FOOTER //
// ./node_modules/@common/client/src/newView.js